export var SecurityAssignmentStatus;
(function (SecurityAssignmentStatus) {
    SecurityAssignmentStatus["SECURITY_UNSPECIFIED"] = "UNSPECIFIED";
    SecurityAssignmentStatus["SECURITY_ASSIGNED"] = "ASSIGNED";
    SecurityAssignmentStatus["SECURITY_NOT_ASSIGNED"] = "NOT_ASSIGNED";
    SecurityAssignmentStatus["SECURITY_EXCLUDED"] = "EXCLUDED";
    SecurityAssignmentStatus["SECURITY_UNSUPPORTED"] = "UNSUPPORTED";
})(SecurityAssignmentStatus || (SecurityAssignmentStatus = {}));
